import { createFileRoute } from '@tanstack/react-router'
import { LinkButton } from '@react-spectrum/s2'
import { Building2, LifeBuoy, Mail, MessageSquareText } from 'lucide-react'
import { trackAnalyticsEvent } from '@client/analytics'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

export const Route = createFileRoute('/contact')({
  component: ContactPage,
  head: () => ({
    meta: [
      {
        title: 'Contact support | BuildingRegs.app',
      },
      {
        name: 'description',
        content:
          'Contact BuildingRegs.app for account, billing, support, sales, and product feedback.',
      },
    ],
  }),
})

function ContactPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background font-sans text-foreground">
      <Header />
      <main
        id="main-content"
        className="mx-auto flex w-full max-w-7xl flex-1 flex-col px-4 py-16 sm:px-6 lg:px-8 lg:py-24"
      >
        <section className="mx-auto w-full max-w-5xl">
          <div className="max-w-3xl">
            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-sm">
              <MessageSquareText className="h-7 w-7" aria-hidden />
            </div>
            <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
              Contact support
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg">
              Tell us what you were trying to do, what went wrong, and the
              account email you used. We can usually investigate faster if you
              include the question you asked and any source or answer that
              looked wrong.
            </p>
          </div>

          <div className="mt-12 grid gap-4 md:grid-cols-2">
            <article className="flex min-h-full flex-col justify-between rounded-lg border border-border/80 bg-card p-6 shadow-sm">
              <div>
                <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-lg bg-secondary text-primary">
                  <LifeBuoy className="h-5 w-5" aria-hidden />
                </div>
                <h2 className="text-xl font-semibold tracking-tight text-foreground">
                  Sales and support
                </h2>
                <p className="mt-3 text-sm leading-6 text-muted-foreground">
                  For account, billing, subscription, answer quality, plan, and
                  procurement questions.
                </p>
              </div>
              <div className="mt-6">
                <LinkButton
                  href="mailto:info@buildingregs.app"
                  size="L"
                  variant="secondary"
                  onPress={() =>
                    trackAnalyticsEvent('contact_info_clicked', {
                      location: 'contact',
                    })
                  }
                >
                  <Mail className="h-4 w-4" aria-hidden />
                  info@buildingregs.app
                </LinkButton>
              </div>
            </article>

            <article className="rounded-lg border border-border/80 bg-card p-6 shadow-sm">
              <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-lg bg-secondary text-primary">
                <Building2 className="h-5 w-5" aria-hidden />
              </div>
              <h2 className="text-xl font-semibold tracking-tight text-foreground">
                Company information
              </h2>
              <div className="mt-5 space-y-4 text-sm leading-6 text-muted-foreground">
                <p className="font-medium text-foreground">
                  Tidy Technology Ltd
                </p>
                <p>
                  <span className="font-medium text-foreground">
                    Registered office
                  </span>
                  <br />
                  71-75 Shelton Street, London, WC2H 9JQ, United Kingdom
                </p>
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
